import {
  createRouter,
  type NavigationGuardNext,
  type RouteLocationNormalizedGeneric,
  type RouteLocationNormalizedLoadedGeneric
} from 'vue-router'
import checkLoginStatus from '@/utils/checkLoginStatus'
import LoginService from '@zaohaowu/website-common/components/AppLogin/login'
import { close, start } from '@/utils/nprogress'
import getDomains from '@/utils/getDomains'
import defaultRouter from './config/default'
import eduRouter from './config/edu'
import { destroyApp as closePostChanllegeModal } from '@/components/AppPostChallenge/postChallenge'

// 是否为教育站点
const isEdu = getDomains().thirdLevelDomain === 'edu'

const router = createRouter(!isEdu ? defaultRouter : (eduRouter as any))

// 判断该路由是否需要登录权限，分为两种登录：1，登录页redirect； 2，直接弹出登录框
const needLogin = async (
  to: RouteLocationNormalizedGeneric,
  from: RouteLocationNormalizedLoadedGeneric,
  next: NavigationGuardNext
) => {
  if (to.meta.needLogin) {
    const isLoggedIn = await checkLoginStatus()
    window.isLoggedIn = isLoggedIn
    // 未登录
    if (!isLoggedIn) {
      // 如果是直接输入链接进入需要登录的页面，则跳转到登录页面
      if (!from.name) {
        next({
          name: 'login',
          query: {
            redirect: to.fullPath
          }
        })
        return
      }
      // 如果是从别的页面点击链接进入需要登录的页面，则返回from页面，并直接原地弹出登录框
      else {
        next(from.fullPath)
      }
      // 弹出登录
      LoginService({
        type: 'login',
        cancel() {},
        onSuccess() {
          // 登录成功后跳转到目标页面
          location.href = to.fullPath
        }
      })
      return
    }
    next()
    return
  }
  next()
}

router.beforeEach(async (to, from, next) => {
  if (to.name !== from.name) {
    //关闭Css全屏视频
    closeVideoCssFullscreen()
    // 关闭发布弹窗
    closePostChanllegeModal()
  }
  start()
  await needLogin(to, from, next)
})

router.afterEach(() => {
  close()
})

// 关闭Css全屏视频
const closeVideoCssFullscreen = () => {
  const videoPlayer = document.querySelector('.player-fullscreen-teleport')
  if (videoPlayer) {
    document.body.removeChild(videoPlayer)
  }
}

export default router
